/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST



export const getCustomerTaskTable = params => {
  return axios.post(`${base}/statistic_customer`, params)
}
export const createCustomerTask = params => {
  return axios.post(`${base}/create_customer`, params)
}
export const getCustomerTaskOptions = params => {
  return axios.get(`${base}/options_customer`, params)
}

export const validateUniqueAbbr = params => {
  return axios.post(`${base}/validate_customer_abbr`, params)
}





// WEBPACK FOOTER //
// ./src/views/customer-task/customer-task.api.js